import { PosMicrosIntegrationExternalPaymentTypes } from '@mews-commander/data-access';
import { EnumSelectField, SelectField } from '@mews-commander/form';
import { FormInputField, lt } from '@mews/framework';
import { Grid } from '@optimus-web/core';
import { useAccountingCategoriesOptions } from '../../hooks/useAccountingCategoriesOptions';
import { FieldNames } from '../fieldNames';

interface PaymentMappingFormProps {
    index: number;
}

export const PaymentMappingForm = ({ index }: PaymentMappingFormProps) => {
    const { accountingCategoriesOptions } = useAccountingCategoriesOptions();
    const paymentMappingIndex = `${FieldNames.paymentMappings}.${index}`;

    return (
        <Grid
            columnGap="200"
            templateRows="repeat(auto-fit, minmax(0, 2fr), minmax(0, 2fr), minmax(0, 2fr))"
            templateColumns="minmax(0, 2fr) minmax(0, 2fr) minmax(0, 2fr)"
            height="100%"
            tabletOnly={{
                templateColumns: 'minmax(0, 3fr) minmax(0, 3fr)',
                templateRows: 'repeat(auto-fit, minmax(0, 3fr), minmax(0, 3fr))',
            }}
            largePhoneOnly={{
                templateColumns: 'minmax(0, 2fr)',
            }}
            phoneOnly={{
                templateColumns: 'minmax(0, 1fr)',
            }}
        >
            <FormInputField
                name={`${paymentMappingIndex}.${FieldNames.paymentNumber}`}
                label={lt('PaymentRoomNumber')}
                required
            />
            <FormInputField name={`${paymentMappingIndex}.${FieldNames.paymasterId}`} label={lt('PaymasterAccount')} />
            <SelectField
                name={`${paymentMappingIndex}.${FieldNames.accountingCategoryId}`}
                label={lt('AccountingCategoryKey')}
                required
                showEmptyValue={false}
                options={accountingCategoriesOptions}
            />
            <EnumSelectField
                name={`${paymentMappingIndex}.${FieldNames.externalPaymentType}`}
                label={lt('ExternalPayment')}
                enumClass={PosMicrosIntegrationExternalPaymentTypes}
                enumPrefix="ExternalPaymentTypes"
                required
            />
        </Grid>
    );
};
